import {DashboardPanelData} from '../../../interfaces/Dashboard';
import {EventTotalKpi} from '../HazardAIEventTotal/EventTotalKpi';

interface Props {
  value?: DashboardPanelData;
  onUpdate?: (value?: DashboardPanelData) => void;
}

export const HazardAIHighSpeedEvent = (props?: Props) => (
  <EventTotalKpi
    {...props}
    filterMode="speed"
    label="High Speed Events"
    errorId="STRA_d3f5b7e9"
  />
);
